module.exports = __webpack_public_path__ + "static/media/foto-destaque-banco-de-pedidos.4b0e9614.jpg";